export default [
  {
    path: "/standardQuery",
    name: "standardQuery", // 标准查询
    component: () =>
      import(
        /* webpackChunkName: "standard" */ "../views/StandardQuery/index.vue"
      ),
    meta: {
      eventId: "W-B-10-V1",
      eventName: "标准列表",
      module: "标准查询",
    },
  },
  {
    path: "/standardFileDetail",
    name: "standardFileDetail", // 标准查询
    component: () =>
      import(
        /* webpackChunkName: "standard" */ "../views/StandardQuery/standardFileDetail.vue"
      ),
    meta: {
      eventId: "W-B-11-V1",
      eventName: "标准详情",
      module: "标准查询",
    },
  },
];
